export default __webpack_public_path__ + "static/media/image-68.cfb64aa2.png";